import { AssessmentResultsFilters } from "./../../../model/assessment";
import {
  ASSESSMENT_EMPLOYEE_RELATIONSHIP,
  ASSESSMENT_RESULTS_FILTERS,
} from "./../../../shared/enums";
import { PayloadAction } from "@reduxjs/toolkit";
import { GenericState } from "../../../shared/utilities";
import { createSlice } from "@reduxjs/toolkit";
import { GENERIC_STATE_STATUS } from "../../../shared/enums";
import {
  AssessmentResponseData,
  AssessmentQuestion,
} from "../../../model/assessment";

export const assessmentStore = createSlice({
  name: "assessment",
  initialState: {
    status: GENERIC_STATE_STATUS.FULFILLED,
    questions: [],
    groupReportsFilters: {
      [ASSESSMENT_RESULTS_FILTERS.FILTER_BY_RESULTS]: null,
      [ASSESSMENT_RESULTS_FILTERS.FILTER_BY_PEOPLE]: null,
    },
  } as GenericState<AssessmentResponseData> & {
    questions: AssessmentQuestion[];
    groupReportsFilters: AssessmentResultsFilters;
  },
  reducers: {
    assessmentCreationStart(state) {
      return {
        ...state,
        status: GENERIC_STATE_STATUS.PENDING,
      };
    },
    assessmentCreationSuccess(
      state,
      action: PayloadAction<AssessmentResponseData>
    ) {
      const { payload } = action;
      return {
        ...state,
        data: payload,
        status: GENERIC_STATE_STATUS.FULFILLED,
      };
    },
    assessmentCreationFail(state) {
      return {
        ...state,
        status: GENERIC_STATE_STATUS.REJECTED,
      };
    },
    assessmentQuestionsFetchSuccess(
      state,
      action: PayloadAction<AssessmentQuestion[]>
    ) {
      return {
        ...state,
        questions: action.payload,
      };
    },
    assessmentQuestionAdditionSuccess(
      state,
      action: PayloadAction<AssessmentQuestion>
    ) {
      return {
        ...state,
        questions: [...state.questions, action.payload],
      };
    },
    assessmentQuestionCategoryPositionIncrement(
      state,
      action: PayloadAction<number[]>
    ) {
      const ids = action.payload;
      const questions = state.questions.map((q) => {
        if (ids.includes(q.categoryId)) {
          return {
            ...q,
            category: q.category
              ? {
                  ...q.category,
                  position: q.category.position + 1,
                }
              : undefined,
          };
        }
        return q;
      });
      return {
        ...state,
        questions,
      };
    },
    assessmentQuestionEditionSuccess(
      state,
      action: PayloadAction<AssessmentQuestion>
    ) {
      const questions = state.questions.slice();
      const questionIndex = questions.findIndex(
        (q) => q.id === action.payload.id
      );
      questions.splice(questionIndex, 1, action.payload);

      return {
        ...state,
        questions,
      };
    },
    assessmentEmptyQuestionCreationSuccess(
      state,
      action: PayloadAction<{ currentId: number }>
    ) {
      const questions = state.questions.slice();
      const questionIndex = questions.findIndex(
        (q) => q.id === action.payload.currentId
      );
      questions.splice(questionIndex, 1);

      return {
        ...state,
        questions,
      };
    },
    assessmentQuestionDeletionSuccess(state, action: PayloadAction<number>) {
      const questions = state.questions.slice();
      const questionIndex = questions.findIndex((q) => q.id === action.payload);
      questions.splice(questionIndex, 1);

      return {
        ...state,
        questions,
      };
    },

    assessmentQuestionsLocalPositionIncrement(
      state,
      action: PayloadAction<AssessmentQuestion[]>
    ) {
      const questions = state.questions.map((q) => {
        const repositionedQuestion = action.payload.find(
          (q_) => q_.id === q.id
        );
        if (repositionedQuestion)
          return { ...q, position: repositionedQuestion.position + 1 };
        return q;
      });

      return {
        ...state,
        questions,
      };
    },
    assessmentQuestionsReorderSuccess(
      state,
      action: PayloadAction<AssessmentQuestion[]>
    ) {
      const questions = state.questions.map((q) => {
        const repositionedQuestion = action.payload.find(
          (q_) => q_.id === q.id
        );
        if (repositionedQuestion) return { ...q, ...repositionedQuestion };
        return q;
      });

      return {
        ...state,
        questions,
      };
    },
    assessmentQuestionsReset(state) {
      return {
        ...state,
        questions: [],
      };
    },
    assessmentGroupReportsResultsFiltersUpdate(
      state,
      action: PayloadAction<ASSESSMENT_EMPLOYEE_RELATIONSHIP | null>
    ) {
      return {
        ...state,
        groupReportsFilters: {
          ...state.groupReportsFilters,
          filterByResults: action.payload,
        },
      };
    },
    assessmentGroupReportsPeopleFiltersUpdate(
      state,
      action: PayloadAction<string | null>
    ) {
      return {
        ...state,
        groupReportsFilters: {
          ...state.groupReportsFilters,
          filterByPeople: action.payload,
        },
      };
    },
  },
});

export const {
  assessmentCreationFail,
  assessmentCreationStart,
  assessmentCreationSuccess,
  assessmentQuestionAdditionSuccess,
  assessmentQuestionDeletionSuccess,
  assessmentQuestionsFetchSuccess,
  assessmentQuestionsReorderSuccess,
  assessmentQuestionEditionSuccess,
  assessmentEmptyQuestionCreationSuccess,
  assessmentQuestionCategoryPositionIncrement,
  assessmentQuestionsLocalPositionIncrement,
  assessmentQuestionsReset,
  assessmentGroupReportsResultsFiltersUpdate,
  assessmentGroupReportsPeopleFiltersUpdate,
} = assessmentStore.actions;
